/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var CustomerAccessAccess;

(function (CustomerAccessAccess) {
  CustomerAccessAccess[CustomerAccessAccess["NONE"] = 'NONE'] = "NONE";
  CustomerAccessAccess[CustomerAccessAccess["MEMBER"] = 'MEMBER'] = "MEMBER";
  CustomerAccessAccess[CustomerAccessAccess["ADMIN"] = 'ADMIN'] = "ADMIN";
})(CustomerAccessAccess || (CustomerAccessAccess = {}));
/**
 * Submission UI layout
 *
 * @public
 */


var FormSubmitLayout;

(function (FormSubmitLayout) {
  FormSubmitLayout["LIST"] = "LIST";
  FormSubmitLayout["TABLE"] = "TABLE";
})(FormSubmitLayout || (FormSubmitLayout = {}));
/**
 * Accepted upload types
 *
 * @public
 */


var FormUploadTypes;

(function (FormUploadTypes) {
  FormUploadTypes["JPG"] = "JPG";
  FormUploadTypes["GIF"] = "GIF";
  FormUploadTypes["PNG"] = "PNG";
  FormUploadTypes["PDF"] = "PDF";
  FormUploadTypes["DOC"] = "DOC";
  FormUploadTypes["DOCX"] = "DOCX";
  FormUploadTypes["XLS"] = "XLS";
  FormUploadTypes["XLSX"] = "XLSX";
  FormUploadTypes["PPT"] = "PPT";
  FormUploadTypes["PPTX"] = "PPTX";
})(FormUploadTypes || (FormUploadTypes = {}));
/**
 * Form status
 * @deprecated ununsed
 * @public
 */


var FormStatus;

(function (FormStatus) {
  FormStatus["ACTIVE"] = "ACTIVE";
  FormStatus["INACTIVE"] = "INACTIVE";
})(FormStatus || (FormStatus = {}));
/**
 * Form key validation strategy
 * @public
 */


var FormValidate;

(function (FormValidate) {
  /**
   * Allow any keys including unknown or new keys
   */
  FormValidate["ANY"] = "ANY";
  /**
   * Allow any _existing_ keys, but reject any new ones
   */

  FormValidate["KEYS_ANY"] = "KEYS_ANY";
  /**
   * Only allows new submissions with _all_ keys
   */

  FormValidate["KEYS_ALL"] = "KEYS_ALL";
})(FormValidate || (FormValidate = {}));
/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


var FormElementType;

(function (FormElementType) {
  FormElementType[FormElementType["DATE"] = 'DATE'] = "DATE";
  FormElementType[FormElementType["EMAIL"] = 'EMAIL'] = "EMAIL";
  FormElementType[FormElementType["FILE"] = 'FILE'] = "FILE";
  FormElementType[FormElementType["LONG_TEXT"] = 'LONG_TEXT'] = "LONG_TEXT";
  FormElementType[FormElementType["NUMBER"] = 'NUMBER'] = "NUMBER";
  FormElementType[FormElementType["PHONE_NUMBER"] = 'PHONE_NUMBER'] = "PHONE_NUMBER";
  FormElementType[FormElementType["SHORT_TEXT"] = 'SHORT_TEXT'] = "SHORT_TEXT";
  FormElementType[FormElementType["TIME"] = 'TIME'] = "TIME";
  FormElementType[FormElementType["URL"] = 'URL'] = "URL";
  FormElementType[FormElementType["CHOICE"] = 'CHOICE'] = "CHOICE";
  FormElementType[FormElementType["RADIO"] = 'RADIO'] = "RADIO";
  FormElementType[FormElementType["BOOLEAN"] = 'BOOLEAN'] = "BOOLEAN";
  FormElementType[FormElementType["CHECKBOX"] = 'CHECKBOX'] = "CHECKBOX";
  FormElementType[FormElementType["PAGE"] = 'PAGE'] = "PAGE";
  FormElementType[FormElementType["GROUP"] = 'GROUP'] = "GROUP";
  FormElementType[FormElementType["STAR_RATING"] = 'STAR_RATING'] = "STAR_RATING";
  FormElementType[FormElementType["NPS"] = 'NPS'] = "NPS";
  FormElementType[FormElementType["HIDDEN"] = 'HIDDEN'] = "HIDDEN";
  FormElementType[FormElementType["DROPDOWN"] = 'DROPDOWN'] = "DROPDOWN";
  FormElementType[FormElementType["PAYMENT"] = 'PAYMENT'] = "PAYMENT";
})(FormElementType || (FormElementType = {}));

var FormElementUploadTypes;

(function (FormElementUploadTypes) {
  FormElementUploadTypes[FormElementUploadTypes["JPG"] = 'JPG'] = "JPG";
  FormElementUploadTypes[FormElementUploadTypes["GIF"] = 'GIF'] = "GIF";
  FormElementUploadTypes[FormElementUploadTypes["PNG"] = 'PNG'] = "PNG";
  FormElementUploadTypes[FormElementUploadTypes["PDF"] = 'PDF'] = "PDF";
  FormElementUploadTypes[FormElementUploadTypes["DOC"] = 'DOC'] = "DOC";
  FormElementUploadTypes[FormElementUploadTypes["DOCX"] = 'DOCX'] = "DOCX";
  FormElementUploadTypes[FormElementUploadTypes["XLS"] = 'XLS'] = "XLS";
  FormElementUploadTypes[FormElementUploadTypes["XLSX"] = 'XLSX'] = "XLSX";
  FormElementUploadTypes[FormElementUploadTypes["PPT"] = 'PPT'] = "PPT";
  FormElementUploadTypes[FormElementUploadTypes["PPTX"] = 'PPTX'] = "PPTX";
})(FormElementUploadTypes || (FormElementUploadTypes = {}));
/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


var FormElementActionAction;

(function (FormElementActionAction) {
  FormElementActionAction[FormElementActionAction["JUMP"] = 'JUMP'] = "JUMP";
  FormElementActionAction[FormElementActionAction["SHOW"] = 'SHOW'] = "SHOW";
  FormElementActionAction[FormElementActionAction["HIDE"] = 'HIDE'] = "HIDE";
})(FormElementActionAction || (FormElementActionAction = {}));
/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


var FormElementActionDetailsToType;

(function (FormElementActionDetailsToType) {
  FormElementActionDetailsToType[FormElementActionDetailsToType["FIELD"] = 'FIELD'] = "FIELD";
  FormElementActionDetailsToType[FormElementActionDetailsToType["HIDDEN"] = 'HIDDEN'] = "HIDDEN";
  FormElementActionDetailsToType[FormElementActionDetailsToType["THANK_YOU"] = 'THANK_YOU'] = "THANK_YOU";
})(FormElementActionDetailsToType || (FormElementActionDetailsToType = {}));
/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Visibility enum
 * @public
 */


var FormKeyVisibility;

(function (FormKeyVisibility) {
  FormKeyVisibility["HIDDEN"] = "HIDDEN";
  FormKeyVisibility["SHOWN"] = "SHOWN";
  FormKeyVisibility["ADMIN"] = "ADMIN";
})(FormKeyVisibility || (FormKeyVisibility = {}));
/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


var ProjectAccessAccess;

(function (ProjectAccessAccess) {
  ProjectAccessAccess[ProjectAccessAccess["NONE"] = 'NONE'] = "NONE";
  ProjectAccessAccess[ProjectAccessAccess["MEMBER"] = 'MEMBER'] = "MEMBER";
  ProjectAccessAccess[ProjectAccessAccess["ADMIN"] = 'ADMIN'] = "ADMIN";
})(ProjectAccessAccess || (ProjectAccessAccess = {}));
/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


var ProviderIdentityProvider;

(function (ProviderIdentityProvider) {
  ProviderIdentityProvider[ProviderIdentityProvider["GOOGLE"] = 'GOOGLE'] = "GOOGLE";
  ProviderIdentityProvider[ProviderIdentityProvider["GITHUB"] = 'GITHUB'] = "GITHUB";
})(ProviderIdentityProvider || (ProviderIdentityProvider = {}));
/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


var UserStatus;

(function (UserStatus) {
  UserStatus[UserStatus["ACTIVE"] = 'ACTIVE'] = "ACTIVE";
  UserStatus[UserStatus["INACTIVE"] = 'INACTIVE'] = "INACTIVE";
})(UserStatus || (UserStatus = {}));

export { CustomerAccessAccess, FormElementActionAction, FormElementActionDetailsToType, FormElementType, FormElementUploadTypes, FormKeyVisibility, FormStatus, FormSubmitLayout, FormUploadTypes, FormValidate, ProjectAccessAccess, ProviderIdentityProvider, UserStatus };